//Custom components
import { NumericFormat as NumberFormat } from 'react-number-format';
import StatCard from '../../../UI/Card/StatCard';

const TotalMarketRentalUnitsWidget = ({ count }: { count: number }) => {
  return <StatCard title='Total Market Rental Units ' stat={<NumberFormat value={count} displayType='text' thousandSeparator={true} />} />;
};

export default TotalMarketRentalUnitsWidget;
